import { translationPacket } from 'common/actions';
import { getDateAndTimeFast } from 'common/services/helpers';
import { StoreState } from 'index';
import React, { useMemo } from 'react';
import { shallowEqual, useSelector } from 'react-redux';

interface DescriptionDayProps {
  start?: number;
  stop?: number;
}

function DescriptionDay(props: DescriptionDayProps) {
  const i18n = useSelector(
    (state: StoreState) => state.i18n,
    shallowEqual
  ) as typeof translationPacket;
  const dateTime = useMemo(
    () =>
      props.start && props.stop
        ? getDateAndTimeFast(props.start, props.stop, i18n.months)
        : { day: '-', month: '-', start: '-:-', stop: '-:-' },
    [props.start, props.stop, i18n.months]
  );

  if (!props.start && !props.stop) {
    return null;
  }

  return (
    <div className="description-date-row" data-test-id="description-day">
      {`${dateTime.day} ${dateTime.month} · `}
      <span className="description-date-row-time">{`${dateTime.start} - ${dateTime.stop}`}</span>
    </div>
  );
}

export default React.memo(DescriptionDay);
